import React, { useState, useEffect } from "react"
import "../styles/preview.css"
import PosterReview from "./PosterPreview"
import MainVidPreview from "./MainVidPreview"
import { imgNameObj } from "./utils"
import { BsPlayFill } from "react-icons/bs"
import { BiInfoCircle } from "react-icons/bi"
import { HiOutlineVolumeUp, HiOutlineVolumeOff } from "react-icons/hi"
import { MdOutlineReplay } from "react-icons/md"

const VideoPreview = ({ data }) => {
    const mob = typeof window !== "undefined" ? window.innerWidth < 1000 ? true : false : false;
    const [videoEnded, setVideoEnded] = useState(false);
    const [showVideo, setShowVideo] = useState(true);
    const [mute, setMute] = useState(false);

    useEffect(() => {
        checkVideo();
    }, [showVideo])

    const checkVideo = () => {
        if (typeof window !== "undefined"){
            if (document.getElementById("poster-preview-vid")){
                if(mute){
                    document.getElementById("poster-preview-vid").muted = true;
                } else {
                    if(!document.getElementById("poster-preview-vid").paused){                        
                        document.getElementById("poster-preview-vid").muted = false;
                    }
                }
            }
        }
    }

    const restartPreview = () => {
        setShowVideo(true);
        setVideoEnded(false);
    }

    const toggleMute = () => {
        if(typeof window !== "undefined"){
            if(document.getElementById("poster-preview-vid").muted){
                setMute(false);
                document.getElementById("poster-preview-vid").muted = false;
            } else {
                setMute(true);
                document.getElementById("poster-preview-vid").muted = true;
            }
        }
    }

    return <div className="vid-prev-outer">
        {
            <div className="vid-prev">
                <div className="disp-info-banner">
                    <div className="disp-actual-data">
                        <div>
                            {/* Change this to imgNameObj[data.v_id] */}
                            <img src={imgNameObj["7b8ad234"]} />
                        </div>
                        <div className="preview-about">
                            {data.about}
                        </div>
                        <div className="preview-play-buttons">
                            <div className="preview-play-more-info mobile-rating-preview">
                                <span style={{ fontSize: "1.2rem" }}>{data.rating}</span><span>stars</span>
                            </div>
                            <div className="preview-play-play">
                                <BsPlayFill style={{ fontSize: "2.2rem" }} /> Play
                            </div>
                            <div className="preview-buttons-middle-filler">
                                &nbsp;&nbsp;&nbsp;
                            </div>
                            <div className="preview-play-more-info">
                                <BiInfoCircle style={{ fontSize: "2rem" }} />{mob ? <span>info</span> : <span>&nbsp; More Info</span>}
                            </div>
                        </div>
                    </div>
                </div>
                <div className="disp-buttons-banner">
                <div className="disp-actual-data">
                        <div className="preview-controls">
                            <div className="preview-sound-control">
                                {
                                    !videoEnded ?
                                    mute ?
                                    <span onClick={e => toggleMute()}><HiOutlineVolumeOff style={{ fontSize: "1.5rem" }} /></span> :
                                    <span onClick={e => toggleMute()}><HiOutlineVolumeUp style={{ fontSize: "1.5rem" }} /></span> :
                                    <span onClick={e => restartPreview()}><MdOutlineReplay style={{ fontSize: "1.5rem" }} /></span>
                                }
                                {typeof window !== "undefined" ? !videoEnded && document.getElementById("poster-preview-vid") ?
                                document.getElementById("poster-preview-vid").addEventListener("ended", () => {
                                    setVideoEnded(true);
                                }) :
                                null : null}
                            </div>
                            <div>
                                &nbsp;&nbsp;&nbsp;
                            </div>
                            <div className="preview-rating-disp">
                                {data.rating} / 10
                            </div>
                        </div>
                    </div>
                </div>
                {
                    !mob ?
                        <MainVidPreview checkVideo={checkVideo} showVideo={showVideo} setShowVideo={setShowVideo} data={data} />
                        :
                        <PosterReview />
                }
                <div className="vid-prev-filler"></div>
            </div>
        }
    </div>
}

export default VideoPreview